import api from '../utils/api';

/** GET /robots — robots for the logged-in client user */
export function getUserRobots() {
  return api.get('/robots');
}

/**
 * PUT /robots/updateip/:robotId
 * @param {string} robotId
 * @param {string} ipAddress — IPv4 only, e.g. "192.168.1.55"
 */
export function updateUserRobotIP(robotId, ipAddress) {
  return api.put(`/robots/updateip/${encodeURIComponent(robotId)}`, {
    IPAddress: ipAddress,
  });
}

/** GET /client/rooms — map rooms for one or more robots */
export function getClientRooms(email, robotIds) {
  const ids = Array.isArray(robotIds) ? robotIds.join(',') : String(robotIds || '');
  return api.get('/client/rooms', { params: { email, robotIds: ids } });
}

/** GET /client/subscription — plan + payment history (account-level) */
export function getClientSubscription(email) {
  return api.get('/client/subscription', { params: { email } });
}

/** GET /user/plan-usage — usage row(s) for logged-in user */
export function getUserPlanUsage(email) {
  return api.get('/user/plan-usage', { params: email ? { email } : {} });
}

/** GET /robot/history/fetch — per-robot disinfection history (90d window) */
export function fetchRobotHistory(robotId) {
  return api.get('/robot/history/fetch', { params: { robotId } });
}

/** GET /robot/history/app — paginated full robot history for user app */
export function fetchRobotHistoryApp(robotId, { page = 1, limit = 20 } = {}) {
  return api.get('/robot/history/app', { params: { robotId, page, limit } });
}

/** GET /robot/history/app/detail — single record including result_map_image */
export function fetchRobotHistoryAppDetail(historyId, robotId) {
  return api.get('/robot/history/app/detail', { params: { historyId, robotId } });
}
